import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: (props: any) => ({
    position: "absolute",
    left: "0",
    top: "3rem",
    display: props.open ? "flex" : "none",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "100%",
    height: "60vh",
    padding: "1rem 8rem",
    backgroundColor: theme.whiteColor,
    boxShadow: "0px 40vh rgb(112,112,112,0.6)",
    fontSize: "0.9rem",
    zIndex: 99,
  }),
  closeBtn: {
    position: "absolute",
    top: "2rem",
    right: "8rem",
    cursor: "pointer",
    zIndex: 1,
  },
  mainLinkContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    height: "2rem",
    textAlign: "center",
    marginTop: "1rem",
  },
  mainLink: (props: any) => ({
    display: "flex",
    alignItems: "center",
    width: "max-content",
    height: "fit-content",
    textTransform: "uppercase",
    color: props.selected ? theme.lightCoralColor : theme.blackColor,
    textDecoration: props.selected ? "underline" : "none",
  }),
  subMenuContainer: (props: any) => ({
    position: "absolute",
    top: "0",
    left: "21.4%",
    display: props.selected ? "flex" : "none",
    flexDirection: "row",
    justifyContent: "flex-start",
    height: "60vh",
    width: "77%",
    padding: "1rem 0",
    paddingLeft: "4.5rem",
    borderLeft: `1px solid ${theme.snowColor}`,
    "& > div:not(:first-child)": {
      marginLeft: "7rem",
    },
  }),
  subLinkContainer: {
    display: "flex",
    flexDirection: "column",
    width: "max-content",
    minWidth: "5rem",
    height: "100%",
  },
  subLink: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    height: "3rem",
    color: theme.lightCoralColor,
    textTransform: "uppercase",
    textDecoration: "underline",
  },
  subSubLinkContainer: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 15rem)",
    width: "100%",
    minWidth: "max-content",
    rowGap: "1rem",
    marginTop: "0.5rem",
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "0.4rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.4rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  },
  subSubLink: {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    fontSize: "0.8rem",
    textDecoration: "none",
    textTransform: "capitalize",
    color: "black",
    marginRight: "3rem",
    "&:hover": {
      color: theme.lightCoralColor,
    },
  },
  featuredBrandContainer: {
    position: "absolute",
    bottom: "2rem",
    left: "21.5%",
    padding: "1rem 0",
    paddingLeft: "4.5rem",
  },
  featuredBrandTitle: {
    textTransform: "uppercase",
  },
  brandContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "2rem",
    marginTop: "2rem",
  },
  brand: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "5rem",
    height: "5rem",
    borderRadius: "10px",
    textDecoration: "none",
    color: theme.darkSlateGrayColor,
    "&:hover": {
      backgroundColor: theme.lightPinkColor,
      opacity: 0.4,
    },
  },
}));

export default useStyles;
